import React, { useEffect, useState } from "react";
import { FormGroup, ModalBody, ModalFooter, Input } from "reactstrap";
import Axios from "../../../lib/Axios";
import ToastHandler from "../../../components/Common/ToastHandler";

const PrivacyPolicyCreateForm = ({ refetch,toggle }) => {

  const [toast, setToast] = useState(false);

  const [toastData, setToastData] = useState({
    title: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await Axios.post("/cms/cms-reset/user-cookie-policy");
      setToastData({
        message: "Submitted",
        title: "Success",
      });
      setToast(true);
    } catch (error) {
      if (error.status === 500) {
        setToastData({
          message: error.response.data.error.message,
          title: "Error",
        });
        setToast(true);
      } else if (error.status === 400) {
        setToastData({
          message: error.response.data.message,
          title: "Error",
        });
        setToast(true);
      }
    }finally{
      toggle()
    }
  };
  const handleCancel = () =>{
    toggle()
  }

  return (
    <>
      <form className="tablelist-form">
        <ModalBody>
          <div className="mb-3">
           <p>Please Confirm you want to <b>reset all users</b> Cookie Policy.</p> 
            <p>In doing so all users will get a notification to accept their new Cookie Policy</p>
          </div>
        </ModalBody>
        <ModalFooter>
        <button
            type="submit"
            className="btn btn-danger"
            onClick={handleCancel}
          >
            Delete
          </button>   
          <button
            type="submit"
            className="btn btn-success"
            onClick={handleSubmit}
          >
            Confirm
          </button>
        </ModalFooter>
      </form>
      <ToastHandler
        open={toast}
        setOpen={setToast}
        duration={2000}
        message={toastData.message}
        title={toastData.title}
      />
    </>
  );
};

export default PrivacyPolicyCreateForm;
